export default ({ app, store }, inject) => {
  // Inject $hello(msg) in Vue, context and store.
  inject('custom$t', (str, obj) => {
    // use `$te` and `$t

    const i18nContents = store.state.settings.contents.i18nContents
    const i18nContent = i18nContents.find(
      (i18nContent) => i18nContent.language === app.i18n.locale
    )
    
    const i18n = app.i18n
    if (i18nContent) {
      const i18nObj = JSON.parse(i18nContent.overview)
      // str should be test.message.item so we need to split it by . and get the last item with recursive function
      const strParts = str.split('.')
      const i18nValue = getI18nValue(i18nObj, strParts)
      if (i18nValue) {
        return i18nValue
      }
    }
    const companyId = store.state.settings.id
    const customStr = str + 'Custom.' + companyId
    return i18n.t && i18n.te
      ? i18n.te(customStr)
        ? i18n.t(customStr, obj)
        : i18n.t(str, obj)
      : i18n.t(str, obj)
      ? i18n.t(str, obj)
      : i18n.t(str, obj)
  })
}

const getI18nValue = (i18nObj, strParts) => {
  if (strParts.length === 1) {
    return i18nObj?.[strParts[0]] || null
  }
  return getI18nValue(i18nObj?.[strParts[0]], strParts.slice(1))
}
